!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : e.StringRaw = n();
}(this, function () {
  "use strict";

  function e(e, n) {
    return n = {
      exports: {}
    }, e(n, n.exports), n.exports;
  }

  var n = {};
  n["typeof"] = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
  };

  var r = e(function (e) {
    e.exports = function () {
      var e = function e(_e) {
        return "function" == typeof _e;
      },
          r = function r(e) {
        var n = Number(e);
        return isNaN(n) ? 0 : 0 !== n && isFinite(n) ? (n > 0 ? 1 : -1) * Math.floor(Math.abs(n)) : n;
      },
          t = Math.pow(2, 53) - 1,
          o = function o(e) {
        var n = r(e);
        return Math.min(Math.max(n, 0), t);
      },
          i = function i(e) {
        if (null != e) {
          if (["string", "number", "boolean", "symbol"].indexOf("undefined" == typeof e ? "undefined" : n["typeof"](e)) > -1) return Symbol.iterator;
          if ("undefined" != typeof Symbol && "iterator" in Symbol && Symbol.iterator in e) return Symbol.iterator;
          if ("@@iterator" in e) return "@@iterator";
        }
      },
          f = function f(n, r) {
        if (null != n && null != r) {
          var t = n[r];
          if (null == t) return;
          if (!e(t)) throw new TypeError(t + " is not a function");
          return t;
        }
      },
          u = function u(e) {
        var n = e.next(),
            r = Boolean(n.done);
        return r ? !1 : n;
      };

      return function (n) {
        var r,
            t = this,
            a = arguments.length > 1 ? arguments[1] : void 0;

        if ("undefined" != typeof a) {
          if (!e(a)) throw new TypeError("Array.from: when provided, the second argument must be a function");
          arguments.length > 2 && (r = arguments[2]);
        }

        var l,
            y,
            c = f(n, i(n));

        if (void 0 !== c) {
          l = e(t) ? Object(new t()) : [];
          var d = c.call(n);
          if (null == d) throw new TypeError("Array.from requires an array-like or iterable object");
          y = 0;

          for (var p, b;;) {
            if (p = u(d), !p) return l.length = y, l;
            b = p.value, a ? l[y] = a.call(r, b, y) : l[y] = b, y++;
          }
        } else {
          var m = Object(n);
          if (null == n) throw new TypeError("Array.from requires an array-like object - not null or undefined");
          var s = o(m.length);
          l = e(t) ? Object(new t(s)) : new Array(s), y = 0;

          for (var h; s > y;) h = m[y], a ? l[y] = a.call(r, h, y) : l[y] = h, y++;

          l.length = s;
        }

        return l;
      };
    }();
  }),
      t = r && "object" === ("undefined" == typeof r ? "undefined" : n["typeof"](r)) && "default" in r ? r["default"] : r,
      o = e(function (e) {
    e.exports = "function" == typeof Array.from ? Array.from : t;
  }),
      i = o && "object" === ("undefined" == typeof o ? "undefined" : n["typeof"](o)) && "default" in o ? o["default"] : o,
      f = function f() {
    for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++) n[r - 1] = arguments[r];

    var t = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0],
        o = void 0;

    try {
      o = i(t.raw);
    } catch (f) {
      throw new TypeError("Cannot convert undefined or null to object");
    }

    return o.map(function (e, r) {
      return t.raw.length <= r ? e : n[r - 1] ? n[r - 1] + e : e;
    }).join("");
  };

  return f;
});